export const TRAIL_LIST = 'trail_list';
export const ATTRIBUTE = 'attribute';
export const EXPLORE_AND_DISCOVER = 'explore_and_discover';
export const GIFTING_UPSELL = 'gifting_upsell';
export const MERCHANDISE_STORE = 'merchandise_store';
export const COMMUNITY_STATS = 'community_stats';
export const SIGNUP_ACTIVITY_SUITABILITY = 'signup_activity_suitability';
export const SEO_LINKS = 'seo_links';
export const UGC_SOCIAL_FOOTER = 'ugc_social_footer';
export const GOOGLEBOT_TRAIL_LIST = 'googlebot_trail_list';
export const UPGRADE_YOUR_ADVENTURES = 'upgrade_your_adventures';
